import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import QuestionIcon from '@assets/svgs/question.svg'
import IdeaIcon from '@assets/svgs/idea.svg'
import AddIcon from '@assets/svgs/add.svg'
import {defaultAvatarUrl} from '@utils/Const'

const BoardItem = ({message}: any) => {
  return (
    <div className={`chat-message board-item`}>
      <img src={defaultAvatarUrl} alt="Avatar" className="avatar" />
      <Flex sx={styles.container}>
        <Flex
          flexDirection={{base: 'column', md: 'row'}}
          alignSelf={'flex-start'}>
          <Image
            src={QuestionIcon}
            h={'36px'}
            alignSelf={{base: 'center', md: 'flex-start'}}
          />
          <Box ml={{base: 0, md: 2}} mt={{base: 2, md: 0}}>
            <Text sx={styles.textHeader}>{message?.message?.question_en}</Text>
            <Text sx={styles.questionVi}>{message?.message?.question_vi}</Text>
          </Box>
        </Flex>
        <Flex
          flexDirection={{base: 'column', lg: 'row'}}
          alignSelf={'flex-start'}
          mb={2}
          mt={2}
          gap={{base: 2, md: 4}}>
          <Box width={{base: '100%', lg: 'auto'}}>
            <Flex sx={styles.headIdea}>
              <Image src={IdeaIcon} />
              <Text sx={styles.textIdea}>{'CORE IDEA'}</Text>
            </Flex>
            <Flex flexDirection={'column'}>
              <Flex sx={styles.triangle}></Flex>
              <Center sx={styles.box}>
                <Text sx={styles.textQuestion} color={CommonColors.blue}>
                  {message?.message?.core_idea_title}
                </Text>
                <Text sx={styles.textIdea1}>
                  {message?.message?.core_idea_question_en}
                </Text>
                <Text sx={styles.textDescription}>
                  {message?.message?.core_idea_question_vi}
                </Text>
              </Center>
              <Text sx={styles.textSentence} color={CommonColors.blue}>
                {message?.message?.user_answer}
              </Text>
            </Flex>
          </Box>

          {message?.message?.supporting_ideas?.length > 0 && (
            <Image
              src={AddIcon}
              mx={{base: 'auto', lg: 8}}
              my={{base: 4, lg: 0}}
              h={{base: '24px', md: '40px'}}
            />
          )}

          {message?.message?.supporting_ideas?.length > 0 && (
            <Box width={{base: '100%', lg: 'auto'}}>
              <Flex sx={styles.headIdea2}>
                <Image src={IdeaIcon} />
                <Text sx={styles.textIdea}>{'SUPPORTING IDEA'}</Text>
              </Flex>
              <Flex
                flexDirection={{base: 'column', md: 'row'}}
                justifyContent={'space-between'}
                gap={4}>
                {message?.message?.supporting_ideas?.map(
                  (item: any, index: any) => (
                    <Flex
                      key={index}
                      flexDirection={'column'}
                      width={{
                        base: '100%',
                        md: 'calc(50% - 8px)',
                        lg: '210px',
                      }}>
                      <Flex sx={styles.triangle2}></Flex>
                      <Center sx={styles.box2}>
                        <Text
                          sx={styles.textQuestion}
                          color={CommonColors.orange}>
                          {item?.highlight_text?.toUpperCase()}
                        </Text>
                        <Text sx={styles.textIdea1}>{item?.text}</Text>
                        <Text sx={styles.textDescription}>{item?.text_vi}</Text>
                      </Center>
                      <Text
                        sx={styles.textSentence}
                        color={CommonColors.orange}>
                        {item?.sentence}
                      </Text>
                    </Flex>
                  ),
                )}
              </Flex>
            </Box>
          )}
        </Flex>
      </Flex>
    </div>
  )
}

const styles = {
  container: {
    borderColor: CommonColors.blue,
    backgroundColor: CommonColors.white,
    padding: {base: '12px', md: '24px'},
    borderRadius: '32px',
    borderWidth: 1,
    marginLeft: '16px',
    minWidth: '80%',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
  },
  box: {
    backgroundColor: 'rgba(229, 242, 255, 0.5)',
    width: '100%',
    minHeight: '100px',
    flexDirection: 'column',
    borderRadius: '16px',
    padding: 4,
    flex: 1,
  },
  box2: {
    backgroundColor: '#FFF8E6',
    flexDirection: 'column',
    minWidth: {base: '100%', md: '210px'},
    minHeight: '100px',
    padding: 4,
    flex: 1,
    borderRadius: '16px',
  },
  circle: {
    width: '120px',
    height: '120px',
    borderRadius: '60px',
    backgroundColor: 'yellow',
    padding: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  image: {
    marginTop: '50px',
    width: '100px',
    height: '60px',
  },
  image2: {
    transform: 'rotate(90deg)',
    width: '50px',
    height: '50px',
  },
  idea: {
    display: 'flex',
    alignItems: 'center',
  },
  headIdea: {
    backgroundColor: CommonColors.blue,
    minWidth: '220px',
    minHeight: '40px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  questionVi: {
    fontWeight: 500,
    fontSize: '14px',
    textAlign: {base: 'center', md: 'left'},
  },
  headIdea2: {
    backgroundColor: CommonColors.orange,
    minWidth: {base: '100%', md: '440px'},
    minHeight: '40px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  textHeader: {
    fontSize: {base: '16px', md: '24px'},
    fontWeight: 600,
    color: CommonColors.shadow,
    textAlign: {base: 'center', md: 'left'},
  },
  textIdea: {
    color: CommonColors.white,
    fontWeight: 600,
    fontSize: '10px',
    marginLeft: '8px',
  },
  triangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    overflow: 'hidden',
    borderTopWidth: 0,
    borderRightWidth: 14,
    borderBottomWidth: 20,
    borderLeftWidth: 14,
    borderTopColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'rgba(229, 242, 255, 0.5)',
    borderLeftColor: 'transparent',
    alignSelf: 'center',
    marginTop: '16px',
  },
  triangle2: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    overflow: 'hidden',
    borderTopWidth: 0,
    borderRightWidth: 14,
    borderBottomWidth: 20,
    borderLeftWidth: 14,
    borderTopColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: '#FFF8E6',
    borderLeftColor: 'transparent',
    alignSelf: 'center',
    marginTop: '16px',
  },
  textIdea1: {
    fontWeight: 500,
    fontSize: '16px',
    color: CommonColors.shadow,
  },
  textQuestion: {
    fontWeight: 700,
    fontSize: {base: '16px', md: '20px'},
  },
  textDescription: {
    fontWeight: 500,
    fontSize: '12px',
    color: CommonColors.shadow,
  },
  textSentence: {
    fontWeight: 600,
    fontSize: '16px',
    marginTop: '8px',
    maxWidth: '100%',
  },
  textTitle: {
    fontWeight: 600,
    fontSize: '24px',
    color: CommonColors.blue,
    marginLeft: '8px',
  },
}

export default BoardItem
